<template>
  <div class="news">
    <div class="title">
      <h3>
        <i class="el-icon-arrow-left"></i> 新增新闻
        <span>带<i>*</i>为必填项</span>
      </h3>
      <div class="internation">
        <button>中文</button>
        <button>英文</button>
      </div>
    </div>

    <div class="formedata">
      <el-form ref="form" :model="sizeForm" label-width="170px" size="mini">
        <el-form-item label="新闻标题·中文:" :required="true">
          <el-input
            v-model="sizeForm.newstitle"
            placeholder="请输入产品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="摘要·中文:" :required="true">
          <el-input
           :rules="[{ required: true, message: '摘要不能为空' }]"
            v-model="sizeForm.abstract"
            type="textarea"
            :rows="4"
            @input="inputArea"
          ></el-input>
          <p>
            字数：还可输入<span>{{ currentLength }}</span
            >字符，最多可输入60个字符（含标点及空格）
          </p>
        </el-form-item>
        <el-form-item label="封面图片:" :required="true">
          <el-upload
            drag
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-remove="handleRemove"
          >
            <div class="el-upload__text">选择文件</div>
          </el-upload>
          <p class="tishi">
            格式：jpg, png, gif; 建议尺寸：693*462px; 大小：2M内；
          </p>
        </el-form-item>
        <el-form-item label="新闻内容·中文:" :required="true">
          <tinymce></tinymce>
        </el-form-item>
        <el-row>
          <button class="submit">提交</button>
          <button class="save">保存</button>
          <button class="preview">预览</button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import tinymce from "../../comment/tinymce.vue";
export default {
  data() {
    return {
      sizeForm: {
        newstitle: "", //新闻标题
        abstract: "", //新闻摘要
      },
      currentLength: 60,
    };
  },
  components: {
    tinymce,
  },
  create() {},
  methods: {
    //监听文本框长度
    inputArea() {
      if (this.sizeForm.abstract.length < 60) {
        this.currentLength = 60 - this.sizeForm.abstract.length;
      } else {
        this.currentLength = 0;
        this.sizeForm.abstract = this.sizeForm.abstract.slice(0, 60);
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
  },
};
</script>
<style  lang='scss' scoped>
.news {
  margin: 17px 26px 20px 26px;
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  background: white;
  height: 785px;
  .title {
    height: 55px;
    padding-left: 26px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 35px;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
    button {
      width: 88px;
      height: 32px;
      border: 1px solid #006fb8;
      color: #006fb8;
      background: white;
      margin-left: 10px;
    }
  }
  .formedata {
    width: 600px;
    margin: 0 auto;
    p {
      font-size: 12px;
      color: #999999;
      span {
        color: red;
      }
    }
    .tishi {
      margin-top: 30px;
    }
    button {
      width: 77px;
      height: 28px;
      border: none;
      border-radius: 2px;
      margin-right: 18px;
    }
    .el-row{
        // border: 1px solid red;
        margin-top: 20px;
        text-align: center;
    }
    .submit {
      background: #006fb8;
      opacity: 0.5;
      color: white;
       margin-left: 26px;
    }
    .save {
      background: #006fb8;
      color: white;
     
    }
    .preview {
      background: #ffffff;
      border: 1px solid #d9d9d9;
      width: #666;
    }
  }
}
</style>
<style scoped>
.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 93px;
  height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
</style>